import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// Components
import SelectLabel from '../../select-label/select-label';

function SelectCourse({ id, title, value, options, isDisabled, handler, selectLabelProps, isRequired }) {
    return (
        <Fragment>
            <label htmlFor={id} className="form__label">
                {title}
            </label>
            <SelectLabel
                value={value}
                listOfOptions={options}
                isRequired={isRequired}
                isSelectDisabled={isDisabled}
                id={id}
                selectHandler={handler}
                {...selectLabelProps}
            />
        </Fragment>
    );
}

SelectCourse.propTypes = {
    id: PropTypes.string,
    title: PropTypes.object,
    value: PropTypes.string,
    options: PropTypes.array,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    handler: PropTypes.func,
    // This props is such as propertyName, visibleProperty
    selectLabelProps: PropTypes.shape({
        propertyName: PropTypes.string,
        visibleProperty: PropTypes.string
    })
};

SelectCourse.defaultProps = {
    isRequired: true
};

export default SelectCourse;



// WEBPACK FOOTER //
// ./components/groups/select-course/select-course.js